<template>
    <section class="user_profile_wrap">
         <div class="title">{{get_local_string.string_42}}</div>
       <template v-if="Object.keys(get_order_profile.data).length === 0">
            <div class="no_order">
                 <img src="~@/assets/no_order.svg" alt="noOrder">
                 <p>{{get_local_string.string_104}}</p>
            </div>
         </template>
        <template v-else>
                 <b-table
           :data="isEmpty ? [] : get_order_profile.data"
            :bordered="isBordered"
            :striped="isStriped"
            :narrowed="isNarrowed"
            :hoverable="isHoverable"
            :loading="isLoading"
            :focusable="isFocusable"
            :mobile-cards="hasMobileCards"
            type="is-dark"
            @click="click_row($event)"
            >

            <b-table-column field="code" :label="get_local_string.string_52" width="40" v-slot="props" >
               <p>#{{props.row.code}}</p>
            </b-table-column>

            <b-table-column field="order from" :label="get_local_string.string_53" v-slot="props" >
               <p>{{props.row.order_from}}</p>
            </b-table-column>

            <b-table-column field="payment" :label="get_local_string.string_54" v-slot="props">
              <p>{{props.row.payment.method}}</p>
            </b-table-column>

            <b-table-column field="delivery" :label="get_local_string.string_19"  v-slot="props">
                <p>{{props.row.delivery.type}}</p>
            </b-table-column>
            <b-table-column field="date" :label="get_local_string.string_55" v-slot="props">
                <span class="">
                  <p>{{props.row.date}}</p>
                </span>
            </b-table-column>
            <b-table-column field="total" :label="get_local_string.string_56" v-slot="props">
                <p><strong>{{props.row.total}} {{get_setting_app.payment.currency}}</strong></p>
            </b-table-column>
        </b-table>
        {{ order_details_row.product_lis}}
        <div id="modal-order" class="uk-modal-container" uk-modal>
    <div class="uk-modal-dialog uk-modal-body">
        <button class="uk-modal-close-default" type="button" uk-close></button>
        <h2 class="uk-modal-title flex_order_modal w-100 mb-4"><span>#{{order_details_row.code}}</span>
            <span class="tag is-dark grand_t">{{get_local_string.string_57}} {{order_details_row.total}} {{get_setting_app.payment.currency}}</span>
        </h2>
          <div class="modal_order_wrap d-block" >
                  <b-table
           :data="isEmpty ? [] : order_details_row.product_list"
            :bordered="isBordered"
            :striped="isStriped"
            :narrowed="isNarrowed"
            :hoverable="isHoverable"
            :loading="isLoading"
            :focusable="isFocusable"
            :mobile-cards="hasMobileCards"
            type="is-dark"
            >
            <!-- <b-table-column field="image" :label="get_local_string.string_58" width="40" v-slot="props" >
               <p class="image_prod_mod"><img :src="props.row.data[0].image" :alt="props.row.data[0].name"></p>
            </b-table-column> -->
            <b-table-column field="Name" :label="get_local_string.string_48"  v-slot="props" >
               <p>{{props.row.data[0].name}}</p>
            </b-table-column>
            <b-table-column field="size" :label="get_local_string.string_59" v-slot="props" >
               <p v-if="props.row.size">{{props.row.size}}</p>
                 <p v-else>-</p>
            </b-table-column>
            <b-table-column field="qty" :label="get_local_string.string_60" v-slot="props">
                <p>{{props.row.qty}}</p>
            </b-table-column>

            <b-table-column field="dough" :label="get_local_string.string_61"  v-slot="props">
                 <p v-if="props.row.dough">{{props.row.dough}}</p>
                 <p v-else>-</p>
            </b-table-column>
            <b-table-column field="Price" :label="get_local_string.string_62" v-slot="props">
                  <p><strong>{{props.row.item_total}} {{get_setting_app.payment.currency}}</strong></p>
            </b-table-column>
             </b-table>
             <div class="total_div">

             </div>
            </div>
    </div>
</div>
        </template>
    </section>
</template>
<script>
import $ from 'jquery';
import { mapActions, mapGetters } from 'vuex';
export default {
    name:'orderprofile',
    data(){
        return{
                isEmpty: false,
                isBordered: false,
                isStriped: true,
                isNarrowed: false,
                isHoverable: true,
                isFocusable: false,
                isLoading: false,
                hasMobileCards: true,
                order_details_row:{}
        }
    },
    computed:{
     ...mapGetters({
         get_order_profile:'get_order_profile',
         get_setting_app:'get_setting_app',
         get_local_string:'get_local_string'
     })
    },
    methods:{
        ...mapActions({
            order_histroy_api:'order_histroy_api'
        }),
        click_row(row_selected){
            // order detaild clicked
            this.order_details_row = row_selected;
            // console.log(this.order_details_row)
            this.uk.modal($('#modal-order')).show();
        }
    },
    mounted(){
        this.order_histroy_api();
    }
}
</script>
<style lang="scss" >
.table.is-hoverable.is-striped tbody tr:not(.is-selected):hover {
    background-color: var(--main_color) !important;
}
table {
strong {
    color: #000;
    font-weight: 700;
}
}
.table thead td, .table thead th {
    color: #000 !important;
}
.box{
.head_box{
    display: flex;
    align-items: center;
    img{
        width: 60px;
        object-fit: contain;
    }
    .order_num{
        padding-left: 10px;
        font-weight: 700;
    }
}
}
.flex_order_modal{
    display: flex;
    align-items: center;
    justify-content: space-between;
    span{
        font-size: 20px;
        font-weight: 600;
    }
}
.image_prod_mod img{
    width: 60px;
    height: 60px;
    object-fit: contain;
}
.table th{
    font-size: 16px;
}
.table {
    background-color: var(--active_color) !important;;
    color: #ffffff !important;;
}
tbody, td, tfoot, th, thead, tr {
    border-color: inherit;
    border-style: solid;
    border-width: 0;
    border-color: var(--active_color) !important;;
}
.table.is-striped tbody tr:not(.is-selected):nth-child(even) {
    background-color: #a28561 !important;
}
.table td, .table th {
    // border: 1px solid #dbdbdb;
    border: 1px solid #a78b68 !important;;
    border-width: 0 0 1px;
    padding: 0.5em 0.75em;
    vertical-align: middle !important;
    color: #1c0a00;
}
.table-wrapper{
    margin-top: 0px !important;
    // border-top: 2px solid #dbdbdb !important;
    padding-top: 0px !important;
}
.b-table .table th .th-wrap {
    justify-content: center;
}
table td{
    text-align: center !important;
}
.grand_t{
    font-size: 16px !important;
}
.user_profile_wrap{
.title{
    font-size: 30px;
    position: relative;
    display: inline-block;
    padding-top: 10px;
    color: var(--active_color);
    border-bottom: 3px solid var(--active_color);
    padding-bottom: 6px;
    }
       .no_order{
        display: block;
        text-align: center;
        img{
            max-width: 550px;
        }
        p{
            font-size: 14px;
            font-weight: 500;
            color: black;
            margin-top: 18px;
        }
    }
}
@media(max-width:992px){
    .user_profile_wrap{
    .no_order{
        display: block;
        text-align: center;
        img{
            max-width: 320px;
        }
    }
}
}
</style>